import { formatBriefDate } from "@/lib/briefs/format";
import styles from "./brief.module.scss";

export default function BriefFolio({ date }: { date: string }) {
    const month = new Intl.DateTimeFormat("en-US", { month: "long", timeZone: "UTC" }).format(
        new Date(`${date}T12:00:00Z`)
    );
    const weekday = new Intl.DateTimeFormat("en-US", { weekday: "long", timeZone: "UTC" }).format(
        new Date(`${date}T12:00:00Z`)
    );
    return (
        <time dateTime={date} aria-label={formatBriefDate(date)} className={styles.folio}>
            <span className={styles.folio_month}>
                {month}
                <span>{date.slice(0, 4)}</span>
            </span>
            <span className={styles.folio_day}>{date.slice(-2)}</span>
            <span className={styles.folio_weekday}>
                {weekday}
                <span className={styles.folio_mark} aria-hidden="true">
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                </span>
            </span>
        </time>
    );
}
